import React from 'react';
import styled from 'styled-components';
import Heading from '../../modules/heading/Heading';
import { LikeIcon } from '../../assets/icons/LikeIcon';
const Receipt: React.FC = () => {
  // TODO: Dont show receipt if a sale didnt go through

  return (
    <Container>
      <div style={{ textAlign: 'left' }}>
        <HeadingContainer>
          <div>
            <Heading text={'Takk for din bestilling!'} size={'l'} tag={'h1'} />
            <p>Du vil få en ordrebekreftelse på e-post</p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column-reverse' }}>
            <LikeIcon />
          </div>
        </HeadingContainer>
        <Heading text={'Dette vil skje fremover:'} size={'s'} tag={'h2'} />

        <StyledParagraph>
          <List>
            <ListItem>
              <ListIcon>1</ListIcon>
              <ListText>
                En av våre medarbeidere vil ta kontakt med deg innen 10 virkedager for å avtale installasjon. Ventetiden
                for installasjon er for tiden to til fire uker. I perioder med mange bestillinger kan det dessverre ta
                noe lengre tid før vi kontakter deg.
              </ListText>
            </ListItem>
            <ListItem>
              <ListIcon>2</ListIcon>
              <ListText>Montøren kommer for installasjon.</ListText>
            </ListItem>
            <ListItem>
              <ListIcon>3</ListIcon>
              <ListText>Du er koblet på nett!</ListText>
            </ListItem>
          </List>
        </StyledParagraph>
      </div>
    </Container>
  );
};

export default Receipt;

const List = styled.ul`
  list-style: none;
  padding: 0;
`;
const ListItem = styled.li`
  margin-top: 1rem;
  text-align: left;
  display: flex;
`;
const ListText = styled.span`
  margin-left: 1rem;
`;
const ListIcon = styled.span`
  font-size: 16px;
  color: #990ae3;
  flex-shrink: 0;
  display: inline-block;
  border: 2px solid #990ae3;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex; /* or inline-flex */
  align-items: center;
  justify-content: center;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HeadingContainer = styled.div`
  align-self: left;
  display: flex;
  flex-direction: row;
`;

const StyledParagraph = styled.div`
  text-align: center;
  max-width: 40rem;
  width: 100%;
`;
